export enum ScheduleUserEvent {
  aftereventdrop = 'aftereventdrop',
  addAvailability = 'addAvailability',
  cellclick = 'cellclick',
  eventclick = 'eventclick',
  addProject = 'addProject'
}
